import { List, Record } from "immutable";
import moment from "moment";

const defaults = {
    components: List<string>(),
    created_at_ms: undefined,
    description: "",
    disable_featured_linesheet: true,
    id: undefined,
    modified_at_ms: undefined,
    name: "",
    page_id: undefined,
    type: "page_layout",
    full_width: false,
};

export class PageLayout extends Record(defaults) {
    declare id: string;
    declare description: string;
    declare type: string;
    declare name: string;
    declare components: List<string>;
    declare page_id: string;
    declare modified_at_ms: moment.Moment;
    declare created_at_ms: moment.Moment;
    declare disable_featured_linesheet: boolean;
    declare full_width: boolean;

    constructor(args) {
        // Remove parseInt when chen changes the value to int instead of string
        super({
            ...args,
            components: List<string>(args.components),
            created_at_ms: moment.utc(parseInt(args.created_at_ms, 10)),
            modified_at_ms: moment.utc(parseInt(args.modified_at_ms, 10)),
        });
    }
}
